<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="terms"
      :columns="table.columns"
      :data="list"
      :actions="table.actions"
      :total="count"
      @add="goToAddPage"
      @edit="goToEditPage($event.id)"
      @delete="showDeleteDialog($event.id)"
      @view="goToProfile($event.id)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

import ComponentTable from '@/components/table/Table';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { listMixin } from '@/mixins/list';

const messages = {
  listError: 'messages.terms.listError',
  getError: 'messages.terms.getError',
  added: 'messages.terms.added',
  addError: 'messages.terms.addError',
  updated: 'messages.terms.updated',
  updateError: 'messages.terms.updateError',
  deleted: 'messages.terms.deleted',
  deleteConfirm: 'messages.terms.deleteConfirm',
  deleteError: 'messages.terms.deleteError'
};

// @vuese
// Lista regulaminów
// @group Terms
export default {
  mixins: [listMixin('terms', messages)],
  components: { ComponentTable },
  data: () => ({
    table: {
      columns: [
        { name: 'name', displayName: 'columns.name', sortable: true },
        { name: 'startDate', displayName: 'columns.startDate', sortable: false }
      ],
      actions: DEFAULT_TABLE_ACTIONS
    }
  }),
  computed: {
    ...mapState({
      list: state => {
        return state.terms.list.map(terms => {
          terms.startDate = moment(terms.start).format('DD-M-Y');
          return terms;
        });
      }
    })
  },
  methods: {
    // Przenosi do formularza dodawania szablonu
    goToAddPage() {
      this.$router.push({ name: 'termsAdd' });
    },
    // Przeniesienie na stronę edycji szablonu
    goToEditPage(termsId) {
      this.$router.push({ name: 'termsEdit', params: { termsId } });
    }
  }
};
</script>
